import useNavigateWithQuery from '../hooks/useNavigateWithQuery';
import Button from './atoms/Button';

interface Props {
  id: string;
  title: string;
  info: string;
  buttonLabel: string;
  redirectPath?: string;
  onButtonClick?: (id: string) => void;
  onClick?: () => void;
  extraButton?: React.ReactNode;
  image?: string;
  icon?: React.ReactNode;
  businessId?: string;
}

const EventMenuOption: React.FC<Props> = ({
  id,
  title,
  info,
  buttonLabel,
  redirectPath,
  onButtonClick,
  onClick,
  extraButton,
  image,
  icon,
  businessId,
}) => {
  const navigate = useNavigateWithQuery();

  const handleButtonClick = () => {
    if (onClick) {
      onClick();
    } else if (!businessId) {
      if (onButtonClick) {
        onButtonClick(id);
      }
      if (redirectPath) {
        navigate(redirectPath);
      }
    } else {
      navigate(`../${businessId}/${redirectPath}`);
    }
  };

  return (
    <div className="flex p-2 flex-col gap-3 bg-blur-sm bg-opacity-light rounded-3xl landing-event-card-shadow cursor-pointer" onClick={handleButtonClick}>
      <div className="flex items-start gap-4">
        {image && (
          <div className="flex-shrink-0">
            <img
              src={image}
              alt="event picture"
              className="w-10 h-10 rounded-lg object-contain align-self-start ml-2 mt-1"
            />
          </div>
        )}
        {icon && (
          <div className="flex-shrink-0">
            {icon}
          </div>
        )}
        <div className="flex flex-col gap-2">
          <div className="flex flex-col self-start pt-1">
            <h1 className="text-xl font-semibold text-text-primary">{title}</h1>
            <p className="text-sm leading-5 text-text-secondary line-clamp-2 min-h-[2.5rem] w-full">{info}</p>
          </div>
          <div className="flex gap-2 w-fit mb-1">
            {/* The card is clickable too: without stopping here one tap ran it twice (F174, F032). */}
            <Button
              onClick={(e) => {
                e.stopPropagation();
                handleButtonClick();
              }}
              variant="secondary"
            >
              {buttonLabel}
            </Button>
            {extraButton}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventMenuOption;
